export default "__VITE_PUBLIC_ASSET__297d5173__"